import React, { Component, Fragment } from 'react';
import styled from 'styled-components';
import { Link } from 'react-router-dom';
import media from 'src/styles/media';

import imgWhiteLogo from 'src/assets/images/618-logo-white.svg';
import imgDarkLogo from 'src/assets/images/618-logo.svg';
import imgMenu from 'src/assets/images/menu-bars.svg';
import Menu from 'src/components/Navigation/Menu';

class Navigation extends Component {
  state = {
    shown: false,
    pastHeader: false,
  };

  componentDidMount() {
    window.addEventListener('scroll', this.handleScrollEvent);
  }

  componentWillUnmount() {
    window.removeEventListener('scroll', this.handleScrollEvent);
  }

  handleScrollEvent = () => {
    if (window.scrollY > window.innerHeight - 50) {
      this.setState({ pastHeader: true });
    } else {
      this.setState({ pastHeader: false });
    }
  };

  handleMenu = () => this.setState({ shown: !this.state.shown });

  render() {
    return (
      <Fragment>
        <Root>
          <Link to="/">
            {window.location.pathname !== '/' && (
              <Logo
                src={this.state.pastHeader ? imgDarkLogo : imgWhiteLogo}
                alt="618 Carnarvon"
              />
            )}
          </Link>
          <div>
            <Button to="/register">Register</Button>
            <MenuButton onClick={this.handleMenu}>
              Menu <img src={imgMenu} alt="Menu Open" />
            </MenuButton>
          </div>
        </Root>
        <Menu shown={this.state.shown} menuClose={this.handleMenu} />
      </Fragment>
    );
  }
}

export default Navigation;

const Root = styled.div`
  position: fixed;
  top: 0;
  width: 100%;
  display: flex;
  justify-content: flex-end;
  padding: 30px 4%;
  z-index: 200;
  @media (min-width: ${media.smup}) {
    justify-content: space-between;
  }
  div {
    display: flex;
  }
`;

const Logo = styled.img`
  display: none;
  width: 68px;
  @media (min-width: ${media.smup}) {
    display: block;
  }
`;

const Button = styled(Link)`
  color: rgba(255, 255, 255, 0.83);
  text-transform: uppercase;
  font-size: 12px;
  font-family: ${({ theme }) => theme.fontHeader};
  background-color: ${({ theme }) => theme.colorPrimary};
  width: 105px;
  height: 35px;
  align-items: center;
  justify-content: space-around;
  border-radius: 30px;
  margin-left: 30px;
  display: none;
  transition: 0.5s ease;
  &:hover {
    box-shadow: 0 0 8px 0 rgba(255, 120, 2, 0.55);
  }
  @media (min-width: ${media.smup}) {
    display: flex;
  }
`;

const MenuButton = styled.div`
  color: rgba(255, 255, 255, 0.83);
  font-family: ${({ theme }) => theme.fontHeader};
  text-transform: uppercase;
  font-size: 12px;
  background-color: ${({ theme }) => theme.colorPrimary};
  width: 105px;
  height: 35px;
  display: flex;
  align-items: center;
  justify-content: space-around;
  border-radius: 30px;
  margin-left: 30px;
  background-color: ${({ theme }) => theme.colorDarkBlue};
  cursor: pointer;
  transition: 0.4s ease-out;
  &:hover {
    box-shadow: 0 0 8px 0 #0b1a27;
  }
`;



// WEBPACK FOOTER //
// ./src/components/Navigation/Navigation.js